import React from "react";
import EastRoundedIcon from "@mui/icons-material/EastRounded";
import useCheckoutFormRenderState from "../../utils/useCheckoutFormRenderState";
import ExpressInterestButton from "../ExpressInterestSection/modules/ExpressInterestButton/ExpressInterestButton";
import {
    checkout_form_types,
    checkout_page_button_types,
} from "../../constants/CheckoutPages.constants";
import CheckoutButton from "../CheckoutButton/CheckoutButton";
import { useCheckoutBasicDetailsContext } from "../CheckoutBasicDetailsContextProvider";

const CheckoutFormButton = (props: { handleShowPaymentModal: () => void }) => {
    const { handleShowPaymentModal } = props;

    const { formToRender } = useCheckoutFormRenderState();
    const {
        checkoutPageButtonType,
        checkoutPageButtonText: { mobileButtonText },
    } = useCheckoutBasicDetailsContext();

    switch (formToRender) {
        case checkout_form_types.express_interest_form: {
            return (
                <ExpressInterestButton
                    type="button"
                    onClick={handleShowPaymentModal}
                />
            );
        }
        case checkout_form_types.payment_form:
        case checkout_form_types.renew_subscription_form: {
            return (
                <CheckoutButton
                    type="button"
                    onClick={handleShowPaymentModal}
                    className="d-flex align-items-center justify-content-center"
                >
                    {checkoutPageButtonType ===
                    checkout_page_button_types.custom ? (
                        mobileButtonText
                    ) : (
                        <>
                            Next
                            <EastRoundedIcon
                                fontSize="small"
                                className="ml-2"
                            />
                        </>
                    )}
                </CheckoutButton>
            );
        }
        default:
            return null;
    }

    return <div>CheckoutFormButton</div>;
};

export default CheckoutFormButton;
